import React from "react";
import { Link } from "react-router-dom";
import { ageCalculate, getImageUrl } from "../utils/utils";

const resolveApprovalStatus = (currentStatus, hasData) => {
  if (currentStatus === "Verified") return "Verified";
  if (currentStatus === "Pending" || hasData) return "Pending";
  return "Not Added";
};

const getNextStatus = (currentStatus) => {
  switch (currentStatus) {
    case "Pending":
      return "Verified";
    case "Verified":
      return "Pending";
    default:
      return "Verified";
  }
};

export const documentApprovalColumns = ({ PAGE_SIZE, handleApproval, openModal, API_URL }) => [
  {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Profile ID",
    width: 120,
    render: (row) => (
      <div className="profile-id">
        <strong>{row.profile_id || "N/A"}</strong>
      </div>
    ),
  },
  {
    label: "User Details",
    render: (row) => (
      <div className="userdet">
        <div>
          <i className="far fa-user" /> {row.name}
        </div>
        <div>
          <i className="far fa-mobile" /> {row.mobile || row.contact_no || "-"}
        </div>
        <div>
          <i className="far fa-envelope" /> {row.email || row.contact_email || "-"}
        </div>
        <div>
          <i className="far fa-mars" /> {row.gender}
        </div>
        <div>
          <i className="far fa-calendar-alt" /> {row.dob ? ageCalculate(row.dob) : '-'} Yrs old
        </div>
      </div>
    ),
  },


  {
    label: "Aadhaar Verified",
    render: (row) => (
      <div className="userdet">



        {row?.userAadhaarVerification ? (
          <>
            <div>
              <i className="far fa-user" /> {row?.userAadhaarVerification?.full_name}
            </div>
            <div>
              DOB : {row?.userAadhaarVerification?.dob}
            </div>
            <div>
              {row?.userAadhaarVerification?.aadhaar_number}
            </div>
            <div>
              <span style={{ color: "green" }}>Verified</span>
            </div>
          </>
        ) : (
          <span>Not Added</span>
        )}
      </div>
    )
  },
  {
    label: "Police Verified ",
    render: (row) => (
      <div className="userdet">
        {row.policeDocument && (
          <a href={getImageUrl(row.policeDocument)} target="_blank" rel="noopener noreferrer">
            View Document
          </a>
        )}
        <br />
        <Link to={"#"}
          onClick={() => openModal(row)}>
          Upload Document
        </Link>
        <br />

        {row.policeApproval === "Verified" ? (
          <span style={{ color: "green" }}>Verified</span>
        ) : row.policeApproval === "Pending" ? (
          <span className="statusactive" style={{ backgroundColor: "orange", textAlign: "center" }}
            onClick={() => {
              if (window.confirm(`Are you sure you want to verify Police document for ${row.name}?`)) {
                handleApproval(row._id, "policeVerification");
              }
            }}
          >{row.policeApproval}</span>
        ) : (
          <span>Not Uploaded</span>
        )}
      </div>
    )
  },
  {
    label: "Education Verified",
    render: (row) => (
      <div className="userdet">
        {(() => {
          const currentStatus = resolveApprovalStatus(row.educationApproval, !!row.highest_degree);
          const nextStatus = getNextStatus(currentStatus);

          if (currentStatus === "Not Added") {
            return (
              <>
                {row.highest_degree && <span>{row.highest_degree.name}</span>}
                <br />
                <span>Not Added</span>
              </>
            );
          }

          return (
            <>
              {row.highest_degree && <span>{row.highest_degree.name}</span>}
              <br />
              <span
                className={currentStatus === "Pending" ? "statusactive" : "verifystatus approved"}
                style={{
                  backgroundColor: currentStatus === "Pending" ? "orange" : "green",
                  color: "#fff",
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "2px 8px",
                  borderRadius: "6px"
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you want to change Education status to ${nextStatus} for ${row.name}?`
                    )
                  ) {
                    handleApproval(row._id, "educationVerification", nextStatus);
                  }
                }}
              >
                {currentStatus}
              </span>
            </>
          );
        })()}
      </div>
    )
  },
  {
    label: "Job & Income Verified",
    render: (row) => (
      <div className="userdet">
        {(() => {
          const currentStatus = resolveApprovalStatus(row.jobIncomeApproval, !!row.working_with);
          const nextStatus = getNextStatus(currentStatus);

          if (currentStatus === "Not Added") {
            return (
              <>
                {row.working_with ? <span>{row.working_with.name}</span> : ""}
                <br />
                <span>Not Added</span>
              </>
            );
          }

          return (
            <>
              {row.working_with ? <span>{row.working_with.name}</span> : ""}
              <br />
              <span
                className={currentStatus === "Pending" ? "statusactive" : "verifystatus approved"}
                style={{
                  backgroundColor: currentStatus === "Pending" ? "orange" : "green",
                  color: "#fff",
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "2px 8px",
                  borderRadius: "6px"
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you want to change Job & Income status to ${nextStatus} for ${row.name}?`
                    )
                  ) {
                    handleApproval(row._id, "jobVerification", nextStatus);
                  }
                }}
              >
                {currentStatus}
              </span>
            </>
          );
        })()}
      </div>
    )
  },
  {
    label: "Caste Verified",
    render: (row) => (
      <div className="userdet">
        {(() => {
          const currentStatus = resolveApprovalStatus(row.casteApproval, !!row.caste);
          const nextStatus = getNextStatus(currentStatus);

          if (currentStatus === "Not Added") {
            return (
              <>
                {row.caste ? row.caste.name : ""}
                <br />
                <span>Not Added</span>
              </>
            );
          }

          return (
            <>
              {row.caste ? row.caste.name : ""}
              <br />
              <span
                className={currentStatus === "Pending" ? "statusactive" : "verifystatus approved"}
                style={{
                  backgroundColor: currentStatus === "Pending" ? "orange" : "green",
                  color: "#fff",
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "2px 8px",
                  borderRadius: "6px"
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you want to change Caste status to ${nextStatus} for ${row.name}?`
                    )
                  ) {
                    handleApproval(row._id, "casteVerification", nextStatus);
                  }
                }}
              >
                {currentStatus}
              </span>
            </>
          );
        })()}
      </div>
    )
  }
];
